// import Erp from '@/assets/js/global.js'
import {ROOT_REQUEST} from '@/assets/configs'


//1, 获取手机验证码
export const RANDOMCODE = `${ROOT_REQUEST.yzmURL}user/getSmsCode1`


//2, 用户密码登录
export const USERLOGIN = `${ROOT_REQUEST.messageURL}user/login`


//3, 用户密码登录
export const SIGNIN = `${ROOT_REQUEST.messageURL}user/login`


//4, 微信扫码登录
export const WECHATSIGNIN = `${ROOT_REQUEST.messageURL}user/loginWithWX`


//5,通过微信openid登录
export const GETAUTHBYOPENID = `${ROOT_REQUEST.messageURL}user/getAuthByOpenId`

//6,用户重置密码
export const FORGETPWD = `${ROOT_REQUEST.bancheBase}v002/user/forgetPwd`
